import $ from 'jquery';

function init() {
  accordionClick()
}

function accordionClick() {
  $('.accordion-title').click(function(e) {
    e.preventDefault()

    const $parent = $(this).parent('.accordion')
    const $text = $(this).next('.accordion-text')

    if($parent.hasClass('accordion--open')) {
      $parent.removeClass('accordion--open')
      $text.slideUp(250)
    } else {
      closeAll();
      $parent.addClass('accordion--open')
      $text.slideDown(250)
    }
  })

}

function closeAll() {
  $('.accordion').removeClass('accordion--open')
  $('.accordion-text').slideUp(250);
}

$(document).ready(function () {
  init()
})
